import { Record, List } from 'immutable';
import type { UserRoleFields } from '~/components/containers/UserManagementContainer/data/UserRole';

const keys: Fields = {
  firstName: '',
  lastName: '',
  roles: List(),
};

interface Fields {
  firstName: string;
  lastName: string;
  roles: List<UserRoleFields>;
}

export default class EditUserUserRecord extends Record<Fields>(keys) {
  constructor(values?) {
    super(values);

    const newValues: Partial<Fields> = {};
    if (values && values.roles) {
      newValues.roles = List(values.roles);
    }

    return this.merge(newValues);
  }

  getFullName() {
    const firstName = this.firstName || '';
    const lastName = this.lastName || '';

    return firstName.concat(' ').concat(lastName);
  }
}
